import { GetSqlVmNetworkInfoApi, type Configuration } from '@repo/api-gw-sdk';
import {
  ListAzureSubscriptionResourceGroupsApi,
  BatchValidateResourceConfigurationApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/azure';

export const azure = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listAzureSubscriptionResourceGroupsApi =
    new ListAzureSubscriptionResourceGroupsApi(config);
  const batchValidateResourceConfigurationApi =
    new BatchValidateResourceConfigurationApi(config);
  const getSqlVmNetworkInfoApi = new GetSqlVmNetworkInfoApi(config);

  return {
    useListSubscriptionResourceGroups: (
      subscriptionId: string,
      requestId: string
    ) =>
      httpClient.execute(
        (
          ...args: Parameters<
            typeof listAzureSubscriptionResourceGroupsApi.listAzureSubscriptionResourceGroups
          >
        ) =>
          subscriptionId
            ? listAzureSubscriptionResourceGroupsApi.listAzureSubscriptionResourceGroups(
                ...args
              )
            : Promise.resolve(undefined),
        baseUrl,
        '',
        currentProjectId,
        subscriptionId,
        requestId
      ),
    batchValidateResourceConfiguration: (resourceIds: string[]) => {
      return batchValidateResourceConfigurationApi.batchValidateResourceConfiguration(
        currentProjectId,
        {
          resourceIds,
        }
      );
    },
    useSqlVmNetworkInfo: (params: {
      cloudAccountId: string;
      resourceGroup: string;
      vmName: string;
    }) => {
      const enabled = Boolean(
        params.cloudAccountId && params.resourceGroup && params.vmName
      );
      return httpClient.execute(
        (
          ...args: Parameters<typeof getSqlVmNetworkInfoApi.getSqlVmNetworkInfo>
        ) =>
          enabled
            ? getSqlVmNetworkInfoApi.getSqlVmNetworkInfo(...args)
            : Promise.resolve(undefined),
        baseUrl,
        'getSqlVmNetworkInfo',
        currentProjectId,
        {
          cloudAccountId: params.cloudAccountId,
          resourceGroup: params.resourceGroup,
          vmName: params.vmName,
        }
      );
    },
  };
};
